import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      container: {
        maxHeight: '601px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: theme.spacing(0),
        overflow: 'hidden',
        boxShadow: '0 1px 2px 0 rgba(90, 100, 90, 0.3)',
        // [theme.breakpoints.up('lg')]: {
        //   maxHeight: '598px',
        // },
      },
      sticky: {
        [theme.breakpoints.up('lg')]: {
          position: 'sticky',
          top: 84,
          height: 'calc(100vh - 116px)',
        },
      },
      headline: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        boxSizing: 'border-box',
        padding: theme.spacing(0.5, 2),
        [theme.breakpoints.down('sm')]: {
          maxHeight: '100%',
          padding: theme.spacing(0, 2),
        },
      },
      title: {
        flex: 'auto',
        fontFamily: '"Exo 2", sans-serif',
        fontWeight: 700,
        fontSize: 16,
        lineHeight: '24px',
        color: sicrediColor.secondarySicrediDarker,
      },
      actions: {
        flexShrink: 1,

        '&.config': {
          display: 'none',

          [theme.breakpoints.down('sm')]: {
            display: 'flex',
          },
        },
      },
      closeIcon: {
        '& > span > svg': {
          width: 20,
        },
      },
      buttonAsk: {
        backgroundColor: theme.palette.primary.dark,
        borderRadius: 20,
        margin: '14px auto',
        minHeight: '44px',
      },
    }),
  { name: 'DuvidasFrequentes' }
);
